import { Toaster as SonnerToaster } from 'sonner';

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      closeButton
      duration={3000}
      toastOptions={{
        classNames: {
          toast: 'group border-border bg-background text-foreground rounded-md shadow-lg',
          title: 'text-sm font-medium',
          description: 'text-xs text-muted-foreground',
        },
      }}
    />
  );
}

// Re-export sonner's toast() so callers import a single place.
export { toast } from 'sonner';
